import React from 'react';
import * as PropTypes from 'prop-types';
import LockIcon from '@material-ui/icons/Lock';
import IconButton from './IconButton';
import Confirmation from './Confirmation';
import { SubjectPropType } from '../../abilities/proptypes';
import { UPDATE } from '../../abilities/actions';

const LockIconButton = ({ onClick, size, confirmLabel, disabled, subject }) => (
    <Confirmation
        popupId="LockIconButton"
        label={confirmLabel || 'Schließen?'}
        onConfirm={onClick}
        disabled={disabled}
    >
        <IconButton size={size} disabled={disabled} subject={subject} action={UPDATE}>
            <LockIcon />
        </IconButton>
    </Confirmation>
);

LockIconButton.propTypes = {
    confirmLabel: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    size: PropTypes.string,
    disabled: PropTypes.bool,
    subject: SubjectPropType,
};

LockIconButton.defaultProps = {
    confirmLabel: null,
    size: null,
    disabled: false,
    subject: null,
};

export default LockIconButton;
